import { adminHeaders } from "./auth";
import { marketplaceHeaders } from "./marketplaceAuth";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export async function createContactRequest(data) {
  const response = await fetch(`${API_URL}/contact-requests`, { method: "POST", headers: { ...marketplaceHeaders(), "Content-Type": "application/json" }, body: JSON.stringify(data) });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.message || "Unable to send your request.");
  return result;
}
export async function fetchContactRequests() {
  const response = await fetch(`${API_URL}/contact-requests`, { headers: adminHeaders() });
  if (!response.ok) throw new Error("Unable to load contact requests.");
  return response.json();
}

export async function fetchSellerContactRequests() {
  const response = await fetch(`${API_URL}/marketplace-auth/seller/contact-requests`, { headers: marketplaceHeaders() });
  const data = await response.json().catch(() => []);
  if (!response.ok) throw new Error(data.message || "Unable to load seller messages.");
  return data;
}
